import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { PropType } from "vue";
import { Employee } from "@/types";
import EmployeeCard from "./EmployeeCard.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeList',
  props: {
    list: {
        type: Array as PropType<Employee[]>,
        required: true,
    },
},
  setup(__props) {



const router = useRouter();

const selectEmployee = (employee: Employee) => {
    router.push({ name: "Employee", params: { id: employee.id } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (employee) => {
      return (_openBlock(), _createElementBlock("li", {
        key: employee.id
      }, [
        _createVNode(EmployeeCard, {
          employee: employee,
          onClick: ($event: any) => (selectEmployee(employee))
        }, null, 8, ["employee", "onClick"])
      ]))
    }), 128))
  ]))
}
}

})